export function getAuthHeaders() {
  const token = localStorage.getItem("sobevenda_token");
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}
